import axios from 'axios';
import { isMobile, browserName, browserVersion, mobileVendor, mobileModel, osName, osVersion } from 'react-device-detect';
import TagManager from 'react-gtm-module';
import { esLocalHost } from '../../../utils/ambiente';
import { store } from '../../../store/configure';

export const processClientData = async () => {
    return new Promise(async(resolve, reject) => {
        var ip = require('ip');
        let data = {
            ipAddress: ip.address()
        };
        if (isMobile) {
            data = { 
                ...data, 
                navegador: browserName,
                navegadorVersion: browserVersion,
                operativeSystem: osName + " on " + mobileVendor + " " + mobileModel,
                operativeSystemVersion: osVersion,
            }
        }
        try {
            const persiste = await persistClientData(data);
            resolve({
                message: persiste.message
            })
        } catch (error){ 
            reject({
                message: error.message
            })
        }


    })
}

export const processIdClientAnalytics = (paso) => {
    return new Promise(() => {
        if(!esLocalHost()) {
            const state = store.getState();
            const idClientAnalyticsState = state.idClientAnalytics;
            const tagManagerArgs = {
                dataLayer: {
                    IdUsuarioAnalytics: idClientAnalyticsState.id,
                    userId: idClientAnalyticsState.id,
                    userProject: 'Banco Hipotecario Onboarding',
                paso
                },
                dataLayerName: 'dataLayer'
            }
            TagManager.dataLayer(tagManagerArgs);
        }
    })
}

export const processEstado = (estado) => {
    return new Promise((resolve, reject) => {
        var data = {
            valor: estado,
        }
        persistEstado(data).then((response) => {
            resolve({
                message: response.message
            })
        }).catch((error) => {
            reject({
                message: error.message
            })
        });
    })
}

const persistClientData = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            data,
            url: localStorage.getItem('url') + '/api/vu/persistClientData'
        }).then((response) => {
            resolve({
                message: 'Datos del cliente persistidos de manera satisfactoria.',
                data: response.data
            })
        }).catch((error) => {
            reject({
                message: 'Error al persistir los datos del cliente.',
            });
        });
    })
}

const persistEstado = (data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            data,
            url:  localStorage.getItem('url') + '/api/vu/persistEstado'
        }).then((response) => {
            resolve({
                message: 'Estado persistido de manera satisfactoria.',
                data: response.data
            })
        }).catch(() => {
            reject({
                message: 'Error al persistir el estado.',
            });
        });
    })
}



// WEBPACK FOOTER //
// ./src/components/OnBoarding/services/pixelService.js